import * as Yup from "yup";

export const formValidationSchema = Yup.object().shape({
    group_coa_id: Yup.string().required("COA group is required !"),
    account_type_code: Yup.string().required("Code is required !"),
    account_type_name: Yup.string().required("Account type group is required !")
});
